module.exports = __webpack_public_path__ + "img/turatel-logo.6fb89909.svg";